export type RealmAccess = Record<string, { roles: string[] }>

export enum UserRole {
    ROLE_CONFIGURATION_ADMIN = 'ROLE_CONFIGURATION_ADMIN',
    ROLE_CONFIGURATION_EDITOR = 'ROLE_CONFIGURATION_EDITOR',
    ROLE_CONFIGURATION_SUPER_ADMIN = 'ROLE_CONFIGURATION_SUPER_ADMIN',
    ROLE_USER_CORPORATE_EDITOR = 'ROLE_USER_CORPORATE_EDITOR',
}

export type AuthTokenParsed = {
    exp: number
    sub: string // the user id
    locale: string
    roles: UserRole[]
    resource_access: RealmAccess
    username: string
    family_name?: string
    given_name?: string
}

export interface AuthState {
    realm: string | null
    token: string | null
    tokenParsed: AuthTokenParsed | null
}
